import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faCode } from "@fortawesome/free-solid-svg-icons"
import { Link, useStaticQuery, graphql } from "gatsby"


export const Projects = () => {
  const data = useStaticQuery(graphql`
    query PartnersQuery {
      allProjectsJson {
        edges {
          node {
            alt
            desc
            live
            source
            tech_Used
            img {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            title
          }
        }
      }
    }
  `)
  

  function getProjects(data) {
    const projectArray = []
    data.allProjectsJson.edges.forEach((item, index) => {
      projectArray.push(
        <div
          key={index}
          className="p-4 w-full sm:w-1/2 md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4  text-center  mb-12 rounded-lg hover:transform skew-y-12"
          style={{transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)"}}
        >
          <div className="bg-white-500 h-full rounded-3xl mb-3 flex flex-col relative overflow-hidden shadow-xl">
            <span className="bg-indigo-500 text-white px-1 h-10 py-2 w-full tracking-widest text-xs absolute right-0 top-0 rounded-bl">
              {item.node.title}
            </span>
            <div
              className="h-60 rounded-2xl"
              style={{
                backgroundImage: `url(${item.node.img.childImageSharp.fluid.src})`,
                backgroundSize: "contain",
                backgroundRepeat:"no-repeat",
                backgroundPosition: "center",
              }}
            ></div>
            <div className="pt-2 pl-4 pr-4 flex bg-transparent items-center text-gray-900 -mt-5 mx-auto w-full">
              <div className="md:p-8 p-2 w-full">
                <p className="text-indigo-500 font-semibold text-sm mt-2">
                  {item.node.tech_Used}
                </p>

                <div className="max-w-full ">
                  <p className="text-base font-medium tracking-wide text-gray-600 ">
                    {item.node.desc}
                  </p>
                </div>
                <div className="flex items-center space-x-2 mt-5">
                  <Link
                    to={item.node.source}
                    className="w-1/2 text-black text-xs text-left rounded-2xl hover:bg-purple-500 hover:text-white py-2 px-1 hover:no-underline"
                  >
                    <FontAwesomeIcon
                      className="bg-transparent text-black-50"
                      icon={faCode}
                      size="sm"
                    />
                    Source Code
                  </Link>


                  <Link
                    to={item.node.live}
                    target="_blank"
                    className={(item.node.alt === "air")? "w-1/2 text-black text-xs rounded-2xl hover:bg-purple-500 hover:text-white py-2 px-1 hover:no-underline hidden":((item.node.alt === "blog")? "hidden w-1/2 text-black text-xs rounded-2xl hover:bg-purple-500 hover:text-white py-2 px-1 hover:no-underline": "block w-1/2 text-black text-xs rounded-2xl hover:bg-purple-500 hover:text-white py-2 px-1 hover:no-underline")}
                  >
                    <FontAwesomeIcon
                      icon={faEye}
                      size="sm"
                      className="bg-transparent text-black-50"
                    />{" "}
                    View Site
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })
    return projectArray
  }

  return (
    <section className="text-gray-600 body-font overflow-hidden hover:mb-5" id="projects">
      <div className="container py-24 mx-auto">
        <div className="flex flex-col text-center w-full mb-20">
          <h1 className="sm:text-4xl text-3xl font-bold title-font mb-2 pb-4 underline text-gray-900">
            Projects
          </h1>
        </div>
        <div className="flex flex-wrap justify-center">{getProjects(data)}</div>
      </div>
    </section>
  )
}
